import React, { useCallback } from 'react'
import classNames from 'classnames'

import { Button } from 'pharmacy/src/input/button'

import { useFlags } from 'launchdarkly-react-client-sdk'

import css from './headerRegisterButton.scss'

export const HeaderRegisterButton = ({ pathname }) => {
  const flags = useFlags()

  const handleRegisterClick = useCallback(
    (e) => {
      e.preventDefault()

      // Evaluate flag only on click
      const useV2 = flags.useV2Onboarding

      // Preserve existing query params (utm_campaign, invitecode, from, etc.)
      const params = new URLSearchParams(window.location.search)

      // Add/override with new params
      params.set('src', pathname.replace(/^\/+/, '') || 'public_home')
      params.set('src_path', pathname)
      params.set('src_item', 'header')

      if (useV2) {
        params.set('mode', 'signUp')
        window.location.href = `/v2/onboarding?${params}`
      } else {
        window.location.href = `/register?${params}`
      }
    },
    [flags, pathname]
  )

  return (
    <>
      <Button
        type="dark_blue"
        className={classNames(css.button, css.displayForLargeScreen)}
        onClick={handleRegisterClick}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
      <Button
        type="orange"
        className={classNames(css.button, css.displayForSmallScreen)}
        onClick={handleRegisterClick}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
    </>
  )
}
